import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { LayoutService } from '../../../services/layout.service';

@Component({
    selector: 'u4-cpp-footer',
    templateUrl: './footer.component.html',
    styles: []
})
export class FooterComponent implements OnInit {
    /**
     * Indicates whether the footer is loaded.
     */
    @Output() loaded = new EventEmitter<boolean>();

    /**
     * The HTML of the global community footer.
     */
    public html: SafeHtml;


    constructor(
        private layoutService: LayoutService,
        private domSanitizer: DomSanitizer
    ) {}

    ngOnInit() {
        this.layoutService.getFooter().subscribe((html: string) => {
            this.html = this.domSanitizer.bypassSecurityTrustHtml(html);
            this.loaded.emit(true);
        });
    }

}
